import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageSelector } from "./LanguageSelector";
import { User } from "@/contexts/AuthContext";
import { useState, useEffect } from "react";
interface NavigationMenuProps {
    isAuthenticated: boolean;
    onClose?: () => void; // Per chiudere il menu in modalità mobile
    handleLogout: () => void;
    layout: "horizontal" | "vertical"; // Definisce il layout
    user?: User;
}

export const NavigationMenu = ({ isAuthenticated, onClose, user, handleLogout, layout }: NavigationMenuProps) => {
    const { t } = useTranslation();
    const [havePicture, setHavePicture] = useState(false);
    const isHorizontal = layout === "horizontal";

    useEffect(() => {
        setHavePicture(!!(user && user.picture));
    }, [user, user?.picture]);

    return (
        <div className={`flex ${isHorizontal ? "flex space-x-8 items-center" : "flex flex-col space-y-4 py-4"}`}>
            <Link to="/" className="text-gray-700 hover:text-primary transition-colors" onClick={onClose}>
                {t("nav.home")}
            </Link>
            {isAuthenticated && (
                <Link to="/dashboard" className="text-gray-700 hover:text-primary transition-colors" onClick={onClose}>
                    {t("nav.dashboard")}
                </Link>
            )}

            {!isAuthenticated ? (
                <>
                    <Link to="/build-diet" className="text-gray-700 hover:text-primary transition-colors" onClick={onClose}>
                        {t("nav.buildDiet")}
                    </Link>

                    <Link to="/signin" className="text-gray-700 hover:text-primary transition-colors" onClick={onClose}>
                        {t("nav.signIn")}
                    </Link>
                    <Link to="/signup" className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/90 transition-colors" onClick={onClose}>
                        {t("nav.signUp")}
                    </Link>
                </>
            ) : (
                <>
                    <Link to="/profile" className="text-gray-700 hover:text-primary transition-colors flex" onClick={onClose}>
                        {havePicture && <img src={user.picture} alt={user.name} className="w-6 h-6 rounded-full block mr-2" />}
                        {t("nav.myProfile")}
                    </Link>
                    {/*
                    <Link to="/payments" className="text-gray-700 hover:text-primary transition-colors" onClick={onClose}>
                        {t("nav.payments")}
                    </Link>
                    */}
                    <button
                        onClick={() => {
                            handleLogout();
                            onClose?.();
                        }}
                        className="text-gray-700 hover:text-primary transition-colors text-left"
                    >
                        {t("nav.logout")}
                    </button>{" "}
                </>
            )}

            <LanguageSelector />
        </div>
    );
};
